import React from "react";

interface RecentIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const RecentIcon: React.FC<RecentIconProps> = ({
  width = 24,
  height = 24,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2 8.8016V12.0032C11.2 12.2272 11.2928 12.4272 11.4408 12.5728L13.4168 14.5488C13.5671 14.6982 13.7705 14.782 13.9824 14.782C14.1943 14.782 14.3977 14.6982 14.548 14.5488C14.6976 14.3984 14.7816 14.1949 14.7816 13.9828C14.7816 13.7707 14.6976 13.5672 14.548 13.4168L12.8 11.6688V8.8032C12.8 8.80213 12.8 8.80107 12.8 8.8V7.2C12.8 6.98783 12.7157 6.78434 12.5657 6.63431C12.4157 6.48429 12.2122 6.4 12 6.4C11.7878 6.4 11.5843 6.48429 11.4343 6.63431C11.2843 6.78434 11.2 6.98783 11.2 7.2V8.8016ZM12 20C7.5816 20 4 16.4184 4 12C4 7.5816 7.5816 4 12 4C16.4184 4 20 7.5816 20 12C20 16.4184 16.4184 20 12 20Z"
        fill={fill}
      />
    </svg>
  );
};

export default RecentIcon;
